import { IThongKeSiSoSelectRequest } from "../../../models/request/thong-ke/IThongKeSiSoSelectRequest";
import { IThongKeSiSoItemRepsone } from "../../../models/response/thong-ke/IThongKeSiSoItemRespone";
import { IThongKeTrangThaiItemRespone } from "../../../models/response/thong-ke/IThongKeTrangThaiItemRespone";
import { generateActionTypeIds } from "../../action-types/generateActionTypeIds";
import IGenericActionType from "../../action-types/IGenericActionType";

export const eThongKeSiSoActionDefine = {
    CHANGE_FILTER: {} as IThongKeSiSoSelectRequest,

    LOAD_START: {} as IThongKeSiSoSelectRequest,
    LOAD_SUCCESS: {} as IThongKeSiSoItemRepsone[],
    LOAD_ERROR: "",

    LOAD_TRANG_THAI_START: {} as IThongKeSiSoSelectRequest,
    LOAD_TRANG_THAI_SUCCESS: {} as IThongKeTrangThaiItemRespone[],
    LOAD_TRANG_THAI_ERROR: "",

    CHANGE_EXPANDED_IDS:{} as Map<string,string>
}
export const eThongKeSiSoActionTypeIds = generateActionTypeIds(eThongKeSiSoActionDefine, "THONG_KE_SI_SO")

export type IThongKeSiSoActionTypes = IGenericActionType<typeof eThongKeSiSoActionDefine, "THONG_KE_SI_SO">